import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useNotificationsStore = defineStore('notificationsStore', () => {
  const notifications = ref<CustomNotification[]>([])

  const notify = (notification: CustomNotification, clear: boolean = false) => {
    if (clear) {
      notifications.value.splice(0)
    }
    notifications.value.push(notification)
    startNotificationTimeout(notification)
  }

  const stopNotificationTimeout = (notification: CustomNotification) => {
    if (notification.timeoutId) {
      clearTimeout(notification.timeoutId)
      notification.timeoutId = undefined
    }
  }

  const startNotificationTimeout = (notification: CustomNotification) => {
      notification.timeoutId = setTimeout(() => {
        const idx = notifications.value.findIndex(n => n.timeoutId === notification.timeoutId);
        if (idx < 0) return;
        notifications.value.splice(idx, 1)
      }, notification.timeout);
  }

  const removeNotification = (notification: CustomNotification) => {
    const idx = notifications.value.findIndex(n => n.timeoutId === notification.timeoutId);
    if (idx < 0) return;
    notifications.value.splice(idx, 1)
  }

  const notifySuccess = (message: string, details?: string, timeout: number = 5000, clear: boolean = false) => {
    notify({ type: 'success', message, details, timeout }, clear)
  }

  const notifyError = (message: string, details?: string, timeout: number = 5000, clear: boolean = false) => {
    notify({ type: 'error', message, details, timeout }, clear)
  }

  const notifyInfo = (message: string, details?: string, timeout: number = 5000, clear: boolean = false) => {
    notify({ type: 'info', message, details, timeout }, clear)
  }

  return { notifications, notifySuccess, notifyError, notifyInfo, stopNotificationTimeout, startNotificationTimeout, removeNotification }
})
